var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.type === "transaction" ? _c('TransactionResult', {
    staticClass: "search_result",
    attrs: {
      "item": _vm.result.data
    }
  }) : _vm.type === "address" ? _c('AddressResult', {
    staticClass: "search_result",
    attrs: {
      "item": _vm.result.data
    }
  }) : _vm.type === "asset" ? _c('AssetResult', {
    staticClass: "search_result",
    attrs: {
      "item": _vm.result.data
    }
  }) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }